import React from "react"
import { EnhancedString, log } from "./functions"

export const basename = "/member"
export const endpoint = process.env.NODE_ENV !== "production" ? "http://localhost:5000" : "https://speakgeorgian.com"
export const qraphqlEndpoint = endpoint + "/graphql"
export const LoginBgArray = ["/img/bg/ushguli.jpg"]

export const initialStateObject: InitialState = {
    token: "",
    authorized: false,
    approved: false,
    id: "",
    isAdmin: false,
    firstName: "",
    lastName: "",
    email: "",
    error: "",
    lang: "en",
    w: {},
    urls: ["/"],
}

//////////// Typescript Types and interfaces
export type Lang = "en" | "fa"
export type UserType = "user" | "admin"
export type PaymentMethod = "paypal" | "tt"

export interface InitialState {
    token: string
    authorized: boolean
    approved: boolean
    isAdmin: boolean
    id: string
    firstName: string
    lastName: string
    email: string
    error: string
    lang: Lang
    w: { [key: string]: string }
    urls: [string]
}

export interface Dispatcher<dispatcherType> {
    dispatch: React.Dispatch<dispatcherType>
}

export interface InputFieldInterface extends Dispatcher<actionObjLocalReducer> {
    field: string
    label: string | React.ReactNode
    state: any
    // validationFn?: stringValidation
    readOnly?: boolean
    type?: string
    defaultValue?: string
    array?: Record<"name" | "code", string>[]
}

export interface InputFieldObj {
    val: string
    err: string
    required: boolean
    validationFn: Function
}
export interface InputFieldState {
    [key: string]: InputFieldObj
}
export interface AppContextInterface {
    globalState: InitialState
    dispatch: React.Dispatch<actionObj>
    t: Function
    log: typeof log
}

export type stateObj = InitialState
export type actionObj = { type: string; payload: any }
export type actionObjLocalReducer = { type: "set-error" | "remove-error" | "set-value" | "set-validationFn"; payload: any }
export type reducerFunction = (state: stateObj, action: actionObj) => stateObj
export type JSON = { [key: string]: any } | { [key: string]: any }[]
export type Translation = (word: string, onlyString?: boolean) => string | EnhancedString
export type stringValidation = (str: string) => string
export interface gqlRequestArgs {
    endpoint?: string
    headers?: {}
    variables?: {}
    query: string
}

export interface matchParams {
    page: string
    lang: Lang
    userType: UserType
}

export type SignUpType = {
    email: string
    password: string
    lang: Lang
    firstName: String
    lastName: String
    hashedLink: string
    method: PaymentMethod
}